import React from "react";
import { useTranslation } from "react-i18next";

const NetworkError = () => {
  const { t } = useTranslation();

  return (
    <div 
      className="lp-wrap lp-middle" 
      id="newtork_error_popup"
      style={{display: 'none', zIndex: 99999}}
    >
      <div className="lp-container lc-alert lc-def">
        <p className="lc-alert_txt m-fw-normal" dangerouslySetInnerHTML={{ __html: t("front_message.msg037") }}>
        </p>
        <div className="lp-btnBox">
          <button className="btn btn-blue" id="network_error_btn">확인</button>
        </div>
      </div>
    </div>
  );

};

export default NetworkError;
